<template>
  <div class="books">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :error.sync="error" error-text="请求失败，点击重新加载"
      @load="onLoad">
      <div v-if="loading || bookshelfList.length > 0">
        <div class="booklist" v-for="item in bookshelfList" :key="item.id" @click="toDetails(item.goodsId)">
          <div class="img_left">
            <img :src="
              item.albumPics
                ? $global.imgUrl + item.albumPics.split(',')[0]
                : require('@/assets/img/mobile-img/zz_default.png')
            " alt="" />
          </div>
          <div class="cent_right" v-html="item.goodsName"></div>
        </div>
      </div>
      <noneList noneType="tsList" v-else />
    </van-list>
  </div>
</template>

<script>
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "books",
  components: {
    noneList,
  },
  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      bookshelfList: [],
      pageNo: 0,
      pageSize: 20,
    };
  },
  methods: {
    onLoad() {
      this.pageNo += 1;
      this.bookshelf();
    },
    async bookshelf() {
      const res = await this.$apis.myServe.bookshelf({
        goodsTypeList: [1],
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      });
      if (res.resultCode == 200) {
        this.finished = res.data.list.length < 20;
        this.bookshelfList.push(...res.data.list);
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    toDetails(id) {
      this.$router.push({
        name: "bookDetails",
        query: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.books {
  .booklist {
    width: 94%;
    height: 104px;
    background: #fff;
    margin: 12px auto;
    border-radius: 8px;
    display: flex;

    .img_left {
      width: 73px;
      height: 73px;
      border-radius: 4px;
      border: 1px solid #eeeeee;
      margin-left: 12px;
      margin-top: 16px;

      img {
        width: 73px;
        height: 73px;
      }
    }

    .cent_right {
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 104px;
      margin-left: 11px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>